module.exports = __webpack_public_path__ + "img/alipayinactive.b6854d29.png";